import merge from 'lodash/merge';
import { LocaleMessage } from 'vue-i18n';
import { Component, Vue } from 'vue-property-decorator';

export type ParameterizedTranslation = (
  // tslint:disable-next-line: trailing-comma
  ...args: any[]
) => string | LocaleMessage;

export interface IDefaultTranslationContent {
  [key: string]: LocaleMessage | ParameterizedTranslation | IDefaultTranslationContent;
}

// export type I18nSubContent = ;
export interface IComputedTranslationContent {
  [key: string]: string | IComputedTranslationContent;
}

@Component
export class I18nMixin extends Vue {
  public overrideI18n!: IComputedTranslationContent;
  public defaultI18n!: IDefaultTranslationContent;
  private tempOverrideI18n: IDefaultTranslationContent = {};

  public beforeMount() {
    const overrideEntries = Object.entries(this.overrideI18n || {});
    if (overrideEntries.length > 0) {
      // default translation can be function so if that's the case we need
      // to wrap the override translation value in a function
      // so the component template does not break
      this.tempOverrideI18n = overrideEntries.reduce(
        (acc: IDefaultTranslationContent, [key, translation]: [string, string | IComputedTranslationContent]) => {
          acc[key] = translation;

          if (typeof this.defaultI18n[key] === 'function') {
            acc[key] = () => translation;
          }

          return acc;
        },
        {},
      );
    }
  }

  get translations(): IDefaultTranslationContent {
    return merge({}, this.defaultI18n, this.tempOverrideI18n);
  }
}
